const ACTIVITIES = 'ACTIVITIES'
const ACTIVITIES_RESET = 'ACTIVITIES_RESET'

export { ACTIVITIES, ACTIVITIES_RESET }
